import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import helpers from 'helpers';
import { letterMapper, AnnotationTooltip } from 'helpers/annotations';

import SelectedTextPopup from './SelectedTextPopup';

const AnnotationsEditor = ({ letterText, annotations }) => {
    const [renderContent, setRenderContent] = useState([]);
    const [openPopover, setOpenPopover] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [chosenText, setChosenText] = useState('');
    const [tooltips, setTooltips] = useState([]);

    const sortForLongerAnnotate = useCallback(ann => _.sortBy(ann, (a, b) => -a.features.string.length), []);

    const clearUnusefullWords = useCallback((ann) => {
        const array = ann.filter(annotation => (
            annotation.type !== 'Lookup' && 
                annotation.type !== 'Sentence' && 
                annotation.type !== 'Split' && 
                _.has(annotation, 'features.rule')
        ));

        const map = new Map();
        for (const item of array) {
            const key = item.type + '-' + item.features.rule + '-' + item.start + '-' + item.end;
            map.set(key, item);
        }

        return Array.from(map.values());
    }, []);

    const createTooltips = useCallback((characters) => {
        const map = new Map();
        for (const char of characters) {
            map.set(char.ids.join(''), char);
        }
        return Array.from(map.values());
    }, []);

    const createRenderedContent = useCallback((_letterText, _annotations) => {
        let _renderContent = _letterText.split('');
        
        _renderContent = _renderContent.map((symbol, symbolPosition) => {
            symbol = symbol === ' ' ? '\u00A0' : symbol;
            return {
                symbol,
                symbolPosition,
                style: {},
                ids: [],
                tooltipContent: [],
            };
        });
        
        for (let i = 0; i < _annotations.length; i++) {
            const hashColor = helpers.createHashColor();
            for (let j = _annotations[i].start; j < _annotations[i].end; j++) {
                if (_renderContent[j]) {
                    _renderContent[j].style = {
                        background: hashColor,
                    };
                    _renderContent[j].ids.push(_annotations[i].id);
                    _renderContent[j].tooltipContent.push({
                        rule: _annotations[i].features.rule,
                        type: _annotations[i].type,
                    });
                }
            }
        }

        const _tooltips = createTooltips(_renderContent);
        
        setRenderContent(_renderContent);
        setTooltips(_tooltips);
    }, []);

    useEffect(() => {
        if (letterText && annotations.length > 0) {
            const clearedAnnotations = clearUnusefullWords(annotations);
            const sortedAnnotations = sortForLongerAnnotate(clearedAnnotations);
            
            createRenderedContent(letterText, sortedAnnotations);
        } else {
            setRenderContent(undefined);
            setTooltips(undefined);
        }
    }, [letterText, annotations, clearUnusefullWords, sortForLongerAnnotate, createRenderedContent]);

    const onMouseUp = (ev) => {
        const range = helpers.getSelection(ev.target.parentNode);
        
        if (range.start === range.end) {
            return;
        }
        
        const hashColor = helpers.createHashColor();
        const newRenderContent = renderContent.slice(0);
        
        newRenderContent.forEach((el) => {
            if (el.position >= range.start && el.position < range.end) {
                newRenderContent.push({
                    style: {
                        background: hashColor,
                    },
                });
            }
        });
        
        setRenderContent(newRenderContent);
        setOpenPopover(true);
        setAnchorEl(ev.target);
        setChosenText(range.string);
    };

    const closePopover = () => {
        setOpenPopover(false);
    };

    return (
        <div>
            <SelectedTextPopup
                openPopover={openPopover}
                anchorEl={anchorEl}
                closePopover={closePopover}
                chosenText={chosenText}
            />
            <div className='letter-text' onMouseUp={onMouseUp}>
                {
                    renderContent
                        ? Array.from(letterMapper(renderContent))
                        : letterText
                }
            </div>
            <AnnotationTooltip
                tooltips={tooltips}
                renderTooltip={tooltip => (
                    <div className='tooltip-row'>
                        {
                            tooltip.tooltipContent.map((t, k) => (<div key={k} className='tooltip-column'>
                                <div className='col'>{`Rule - ${t.rule}, `}</div>
                                <div className='col'>{`Type - ${t.type}`}</div>
                            </div>))
                        }
                    </div>
                )}
            />
        </div>
    );
};

export default connect(
    (state, ownProps) => ({
        annotations: state.annotations.items,
    }),
    null,
)(AnnotationsEditor);



// WEBPACK FOOTER //
// ./app/components/Letters/common/AnnotationsEditor.jsx